import { Configuration, getConfiguration } from '../internal';
import { axios } from '../internal';

let config: Configuration | null = null;
let uri = '';

export const ping = async () => {
  if (!config) {
    config = await getConfiguration();
    const contextPath = config.get('contextPath');
    if (contextPath) {
      uri = `${contextPath}/keepalive`;
    }
  }

  if (uri) {
    axios.get(uri);
  }
};
